import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { checkPermissionStatus, useDebounce } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";

import serach_icon from "../../assets/images/icon/search-icon.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

import { useTranslation } from "react-i18next";
import {
  DeleteRoundTemplate,
  FetchAllRoundTemplates,
} from "services/RoundTemplateServices";
import moment from "moment";
import Swal from "sweetalert2";
import RemotePagination from "components/Common/RemotePagination";
import { Spinner } from "reactstrap";
import CreateRoundTemplateModal from "./CreateRoundTemplateModal";

const RoundTemplate = ({ ...props }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [allTemplates, setAllTemplates] = useState([]);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [queryText, setQueryText] = useState("");
  const debouncedQueryText = useDebounce(queryText, 500);

  const [addModal, setAddModal] = useState(false);

  const fetchData = async ({
    _pageNo = pageNo,
    _pageSize = pageSize,
    _queryText = queryText,
  }) => {
    try {
      setLoading(true);

      let reqBody = {
        queryText: _queryText,
        pageNo: _pageNo,
        pageSize: _pageSize,
      };

      let response = await FetchAllRoundTemplates(reqBody);

      let responseData = decryptDataFromArray(response);

      setAllTemplates(responseData?.templateList || []);
      setTotalTemplates(responseData?.total);
      setLoading(false);
    } catch (error) {
      toast.error(t(`Round Template.No Templates Available`));
      setAllTemplates([]);
      setTotalTemplates(0);
      setLoading(false);
    }
  };

  const handleDeleteTemplate = async tempId => {
    try {
      let response = await DeleteRoundTemplate(tempId);

      let responseMsg =
        response?.data?.message || "Template Deleted Successfully";

      toast.success(responseMsg);

      fetchData({});
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Error while deleting template";

      toast.error(errMsg);
    }
  };

  useEffect(() => {
    fetchData({
      _queryText: debouncedQueryText,
    });

    return () => {};
  }, [debouncedQueryText]);

  const columns = [
    {
      dataField: "name",
      text: t(`Round Template.Name`),
    },
    {
      dataField: "InterviewTitles",
      text: t(`Round Template.Rounds`),
      formatter: (rounds, temp) => {
        let sorted = rounds?.sort(
          (r1, r2) =>
            r1?.round_template_interview?.round_order -
            r2?.round_template_interview?.round_order
        );

        return (
          <ol>
            {sorted?.map(r => (
              <li key={r?.id}>
                {r?.interview_title?.trim()} [{r?.round_type}]
              </li>
            ))}
          </ol>
        );
      },
    },
    {
      dataField: "updated_at",
      text: t(`Round Template.Last Updated On`),
      classes: "white-hidden",
      formatter: (updated_at, temp) => {
        return <>{moment(updated_at).format("DD MMM, YYYY")}</>;
      },
    },
  ];

  if (checkPermissionStatus("round-template", "delete")) {
    columns.push({
      dataField: "id",
      text: t(`Round Template.Actions`),
      formatter: (tempId, temp) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            {checkPermissionStatus("round-template", "delete") ? (
              <div className="action-one small-img">
                <div
                  className="text-success blue-icon blue-color3"
                  role="button"
                  onClick={e => {
                    Swal.fire({
                      title: t("Round Template.Are you sure?"),
                      text: t(
                        "Round Template.You won't be able to revert this"
                      ),
                      icon: "warning",
                      showCancelButton: true,
                      cancelButtonColor: "#d33",
                      cancelButtonText: t("Round Template.Cancel"),
                      confirmButtonColor: "#3085d6",
                      confirmButtonText: t("Round Template.Delete"),
                      reverseButtons: true,
                    }).then(async result => {
                      if (!result.isConfirmed) {
                        return;
                      }

                      handleDeleteTemplate(tempId);
                    });
                  }}
                >
                  <img src={delete_icon} alt="delete_icon" />
                  <span>{t(`Round Template.Delete Round Template`)}</span>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        );
      },
    });
  }

  /**table arrow */
  const tableWrapperRef = useRef(null);

  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setTimeout(() => {
      setPageNo(page);
      setPageSize(sizePerPage);
      fetchData({ _pageNo: page, _pageSize: sizePerPage });
    }, 500);
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("round-template", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Round Template.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <div className="page-content departmentpage">
      <Container fluid>
        <div className="joblist-container skilllist  applicationcard-table">
          <Row className="mb-3 align-items-center py-2 spece-low-cum2">
            <Col lg="4" md="4" className="Joblist-column">
              <div className="joblist-container create-vacancy p-0">
                <div
                  role="button"
                  onClick={() => {
                    if (typeof props?.history?.goBack === "function") {
                      props?.history?.goBack();
                    } else {
                      props?.history?.push("/dashboard");
                    }
                  }}
                >
                  <h5 className="text-uppercase heading-one spece-low-cum2">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Round Template.Round Template List`)}
                  </h5>
                </div>
              </div>
            </Col>
            <Col lg="8" md="8">
              <div className="single-filter-box skillset-card btn-left d-flex justify-content-end align-items-center gap-2 flex-wraps">
                <div className="serach-bar-top">
                  <form className="form-inline">
                    <input
                      className="form-control mr-sm-2"
                      type="search"
                      placeholder={t(`Round Template.Search template`)}
                      aria-label="Search"
                      onChange={e => {
                        let text = e.target?.value;

                        setQueryText(text);
                      }}
                      title={t(`Round Template.Search template`)}
                    />
                    <span>
                      <img src={serach_icon} alt="search" />
                    </span>
                  </form>
                </div>

                {checkPermissionStatus("round-template", "create") && (
                  <div
                    role="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setAddModal(true);
                    }}
                  >
                    {t(`Round Template.Create Round Template`)}
                  </div>
                )}

                <div className="tale-text right-panel skilltest">
                  <button
                    className="button left"
                    onClick={() => handleScroll("left")}
                    data-tooltip="Scroll Left"
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                  <button
                    className="button right"
                    onClick={() => handleScroll("right")}
                    data-tooltip="Scroll Right"
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <Row>
          <Col lg={12}>
            <div className="outerTab-box-wrapper below-vacancy  skillset-cards-po">
              <div className="timeto-hire-card userlist">
                {!!loading && (
                  <div className="m-3 p-3 text-center">
                    <Spinner size={"lg"} />{" "}
                    <div>{t(`Round Template.Loading`)}</div>
                  </div>
                )}

                {!loading && (
                  <div className="table-custome-class range-custome">
                    {!!allTemplates?.length ? (
                      <>
                        <div className="scroll-container">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <RemotePagination
                              keyField="id"
                              data={allTemplates}
                              columns={columns}
                              page={pageNo}
                              sizePerPage={pageSize}
                              totalSize={totalTemplates}
                              onTableChange={handleTableChange}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <table className="table table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>{t(`Round Template.Name`)}</th>
                              <th>{t(`Round Template.Actions`)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="4" className="text-center">
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>
                                    {t(`Round Template.No Templates Available`)}
                                  </h3>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <CreateRoundTemplateModal
        t={t}
        addModal={addModal}
        setAddModal={setAddModal}
        fetchData={fetchData}
      />
    </div>
  );
};

export default RoundTemplate;
